import { createAsyncThunk } from "@reduxjs/toolkit";
import type { Dependencies } from "@redux/store";
import type { TeacherVM } from "@shared-kernel/application/ports/teacher/teacher-repository";

export const retrieveTeacherProfile = createAsyncThunk<TeacherVM, void, { extra: Partial<Dependencies> }>(
  "teachers/retrieveTeacherProfile",
  async (_: void, { extra: { teacherRepository } }) => {
    return teacherRepository!.profile();
  },
);
